import { useState, useEffect } from 'react';

export default function AdBlockerNotice() {
  const [detected, setDetected] = useState(false);
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem('adblock_dismissed') === '1'
  );

  useEffect(() => {
    if (dismissed) return;

    const bait = document.createElement('div');
    bait.className = 'ad adsbox pub_300x250';
    bait.style.cssText = 'position:absolute;top:-999px;left:-999px;width:1px;height:1px;';
    document.body.appendChild(bait);

    const timer = setTimeout(() => {
      if (bait.offsetHeight === 0) setDetected(true);
      document.body.removeChild(bait);
    }, 200);

    return () => {
      clearTimeout(timer);
      if (document.body.contains(bait)) document.body.removeChild(bait);
    };
  }, [dismissed]);

  if (!detected || dismissed) return null;

  function handleDismiss() {
    localStorage.setItem('adblock_dismissed', '1');
    setDismissed(true);
  }

  return (
    <div className="sticky top-14 z-20 bg-amber-50 dark:bg-amber-900/30 border-b border-amber-200 dark:border-amber-700/50 px-4 py-2.5 flex items-center justify-between gap-4">
      <p className="text-sm text-amber-800 dark:text-amber-200">
        We noticed you&apos;re using an ad blocker. OptionView is free — please consider supporting us by disabling it.
      </p>
      <button
        onClick={handleDismiss}
        className="flex-shrink-0 text-sm font-medium text-amber-700 dark:text-amber-300 hover:text-amber-900 dark:hover:text-amber-100 underline"
      >
        Dismiss
      </button>
    </div>
  );
}
